import { Box, styled } from '@ori-ui/mui';

export const Root = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: 'inherit',
  justifyContent: 'center',
  textAlign: 'center',
});
